import { type IterationTeamMemberAttributes } from './generated/IterationTeamMemberAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface IterationTeamMember extends IterationTeamMemberAttributes {}

@model
class IterationTeamMember extends ApplicationModel {
  // Start auto-generated
  static typename: 'IterationTeamMember' = 'IterationTeamMember';
  get typename(): 'IterationTeamMember' {
    return 'IterationTeamMember';
  }

  static fields = {
    hasNonWorkingDays: attr({ readable: true }),
    id: attr({ readable: true }),
    path: attr({ readable: true }),
    storyPoints: attr({ readable: true }),
    workingHours: attr({ readable: true }),
    iteration: attr.belongsTo({ readable: true, typename: 'Iteration' }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated
}

export default IterationTeamMember;
